<template>
  <div>
        <div
      class="background-image-dashboard"
        :style="[settings.loginBackgroundImage && settings.loginBackgroundImage.absoluteUri ? {'backgroundImage': 'url(' + settings.loginBackgroundImage.absoluteUri + ')'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]"
     ></div>
<!-- /.background-image-dashboard -->
    <base-header class="pt-4 pb-6" type="none">
      <b-row align-h="center">
        <b-col cols="4" class="text-center">
          <h1 class="page-title" v-if="pageTitle">{{ pageTitle }}</h1>

          <p class="text-lead text-white mb-2" v-if="pageEntry">{{ pageEntry }}</p>
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--5">
      <b-row class="js-sticky-container" data-sticky-container>
        <b-col xl="8">
          <my-recipes-table></my-recipes-table>

          <b-row class="js-masonry-init">
            <b-col class="js-masonry-item" xl="6" v-for="(article,index) in articles" :key="index">
              <b-card no-body class="card-article">
                <!-- Card image -->
                <div :class="'card-img-top' + articleImageClass(article)">
                  <img :src="article.img" :alt="article.img_alt" v-if="article.img">
                </div>
                <!-- Card body -->
                <b-card-body>
                  <div class="card-badge" v-if="article.badge">
                    <p>
                      <strong>{{ article.badge }}</strong>
                      {{ articlesBadgeText }}
                    </p>
                  </div><!-- /.card-badge -->
                  <b-card-title class="h2 mb-0">{{ article.title }}</b-card-title>
                  <small class="text-muted">{{ article.meta }}</small>
                  <b-card-text class="mt-4">{{ article.description }}</b-card-text>
                  <div class="d-flex justify-content-between align-items-center">
                    <!-- <a :href="article.url" class="btn btn-link px-0">{{ article.link_more }}</a> -->
                    <a href="#!" class="btn btn-link px-0">{{ article.link_more }}</a>
                    <div class="icon-actions">
                      <a href="#" class="like active" @click="handleLike($event, index, article)">
                        <i class="ni ni-like-2"></i>
                        <span class="text-muted">{{ article.likes }}</span>
                      </a>
                      <a href="#">
                        <i class="ni ni-chat-round"></i>
                        <span class="text-muted">{{ article.comments }}</span>
                      </a>
                      <a href="#">
                        <i class="ni ni-curved-next"></i>
                        <span class="text-muted">{{ article.shares }}</span>
                      </a>
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-col>

        <b-col xl="4">
          <to-do-list class="js-sticky"></to-do-list>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import swal from 'sweetalert2';
import Sticky from 'sticky-js';
import Masonry from 'masonry-layout';

// Components
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

// Lists
import ToDoList from '../Lists/ToDoList';

// Tables
import MyRecipesTable from '../Tables/MyRecipesTable';

export default {
  components: {
    RouteBreadCrumb,
    ToDoList,
    MyRecipesTable,
  },
  data() {
    return {
      data: null,
      randomEntry: {},
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings.current;
    },
    pageTitle() {
      return this.data && this.data.pages.dashboard.title;
    },
    pageEntry() {
      return this.randomEntry && this.randomEntry.text;
    },
    articles() {
      return this.data && this.data.articles.data;
    },
    articlesBadgeText() {
      return this.data && this.data.articles.badge_text;
    }
  },
  methods: {
    handleLike(event, index, article) {
      event.preventDefault();

      const likeButton = event.target.closest('.like');

      if (likeButton) {
        likeButton.classList.contains('active') ? article.likes-- : article.likes++;
        likeButton.classList.toggle('active');
      }
    },
    articleImageClass(element) {
      return element.img_class ? ' card-img-top--' + element.img_class : '';
    },
    initMasonry() {
      setTimeout(function(){
        const grid = document.querySelector('.js-masonry-init');
        const options = {
          columnWidth: '.js-masonry-item',
          itemSelector: '.js-masonry-item',
          percentPosition: true
        }

        let msnry = new Masonry(grid, options)
      })
    },
    initSticky() {
      let sticky = new Sticky('.js-sticky', {
        marginTop: 100
      });
      let button = document.querySelector('.sidenav-toggler');

      button.addEventListener('click', function(){
        setTimeout(function(){
          sticky.update();
        }, 150)
      });
    },
    getDashboardData() {
      return 'hostname';
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
    this.initMasonry();
    this.initSticky();
  }
};
</script>
<style></style>
